exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#privacyEn {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacyEn h1 {\n  font-weight: bold;\n  font-size: 0.2rem;\n}\n#privacyEn div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacyEn div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacyEn div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacyEn div a {\n  color: #000;\n}\n#privacyEn div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-695f05c3","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/module/terms_en/terms_en.vue
// module id = 95
// module chunks = 8 11 19